
<template>
  <div>
    <dialog-edit-client></dialog-edit-client>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditClient from '../../components/client/DialogEditClient.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ShowClientPage',
  //mixins: [ validations ],
  components: {
    DialogEditClient
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>